import { createSelector } from "reselect";

import { INITIAL_REQUEST_STATE } from "@skydio/redux_util/src";

import { paginationStateToProps } from "../pagination/utils";
import { NEW_USER_PLACEHOLDER_EMAIL } from "./types";

import { UsersState, initialUserState } from "./slice";

export const getUsersRequest = ({ requests }: UsersState) => requests.users;

export const getUsersQueryTimeout = ({ state }: UsersState) => state.dispatchTimeout;

export const isUsersRequestActive = (state: UsersState) => getUsersRequest(state).active;

export const getUserRequest = (state: UsersState, uuid: string) =>
  state.requests.user[uuid] ?? INITIAL_REQUEST_STATE;

export const isUserRequestActive = (state: UsersState, uuid: string) =>
  getUserRequest(state, uuid)?.active;

export const getNewUserRequest = (state: UsersState) =>
  getUserRequest(state, NEW_USER_PLACEHOLDER_EMAIL);

export const getAllUsers = ({ state }: UsersState) => state.users;

export const getUser = (state: UsersState, uuid: string) =>
  getAllUsers(state)[uuid] ?? initialUserState;

export const getUserModifications = (state: UsersState, uuid: string) =>
  getUser(state, uuid).modified;

const getUsersRequestUUIDs = ({ state }: UsersState) => state.requestedIds;

export const getUsersForRequest = createSelector(
  getUsersRequestUUIDs,
  getAllUsers,
  (userUuids, users) => userUuids.map(uuid => users[uuid])
);

export const getUsersPagination = ({ state }: UsersState) => state.pagination;

export const getUsersPaginationProps = createSelector(getUsersPagination, paginationStateToProps);

export const getPilots = createSelector(getAllUsers, users =>
  Object.values(users).filter(user => user.organizationFlightCount > 0)
);

export const getOrgRemovalRequest = (state: UsersState, email: string) =>
  state.requests.orgRemovals[email] || INITIAL_REQUEST_STATE;

export const getAcceptOrgInviteRequest = (state: UsersState) => state.requests.acceptedOrgInvite;
